<template>
    <Modal
        okOnly
        size="lg"
        centered
        hide-footer
        is-modal-route
        :no-close-on-esc="isSubmitting"
        :hide-header-close="isSubmitting"
        :no-close-on-backdrop="isSubmitting"
        :ok-title="$t('form.button.send')"
        :title="$t('talk.form.createTemplate')"
    >
        <Form :isSubmitting="isSubmitting" @submit="onSubmit" />
    </Modal>
</template>
<style scoped src="../modalStyles.scss" lang="scss"></style>
<script>
import { Form } from '../../components'
import { createTemplate } from '../api'
import Modal from '@/views/components/modal'

import notification, { danger, success } from '@/lib/notification'

notification.init()

export default {
    components: {
        Modal,
        Form,
    },
    data() {
        return {
            isSubmitting: false,
        }
    },
    methods: {
        onSubmit(data) {
            this.isSubmitting = true
            createTemplate(data)
                .then(template => {
                    success(
                        this.$t('notification.createdSuccessfully', {
                            item: this.$t('talk.template'),
                        })
                    )
                    this.$emit('template-created', template)
                    this.$router.back()
                })
                .catch(error => {
                    console.log(error)
                    danger()
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
    },
}
</script>
